import React, { useState } from 'react';

const VerticalTabs = ({ items }) => {
   // console.log({ items });
    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };


    return (

        <>
            <div className="flex flex-col lg:flex-row my-10">

                <div className="vertical-tabs ">
                    <div>
                    {items.map((item, index) => (
                        <div
                            key={index}
                            className={`tab ${index === activeTab ? 'active' : ''}`}
                            onClick={() => handleTabClick(index)}
                        >
                            {item.title}
                        </div>
                    ))}
                    </div>
                </div>

                <div className="lg:w-2/3">
                    <div className="custom-content">
                        <h2 className="tab-title">{items[activeTab].title}</h2>
                        <div dangerouslySetInnerHTML={{ __html: items[activeTab].content }}></div>
                    </div>
                </div>
            </div>

        </>

    );
};

export default VerticalTabs;
